"use client"

import { clx } from "@medusajs/ui"
import {
  SelectHTMLAttributes,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react"

import ChevronDown from "@modules/common/icons/chevron-down"

type NativeSelectProps = {
  placeholder?: string
  errors?: Record<string, unknown>
  touched?: Record<string, unknown>
} & Omit<SelectHTMLAttributes<HTMLSelectElement>, "size">

const CartItemSelect = forwardRef<HTMLSelectElement, NativeSelectProps>(
  ({ placeholder = "Select...", className, children, ...props }, ref) => {
    const innerRef = useRef<HTMLSelectElement>(null)

    useImperativeHandle<HTMLSelectElement | null, HTMLSelectElement | null>(
      ref,
      () => innerRef.current
    )

    return (
      <div className={clx("shrink-0", className)}>
        <div className="relative inline-flex h-7 w-[48px] items-center overflow-hidden rounded-full bg-gradient-to-b from-green-500 to-green-700 ring-1 ring-green-800 shadow-[0_3px_6px_rgba(0,0,0,0.35),inset_0_1px_0_rgba(255,255,255,0.25)]">
          <select
            ref={innerRef}
            {...props}
            className="h-9 w-[55px] appearance-none bg-transparent border-0 pl-3 pr-7 text-center text-sm font-bold text-white outline-none"
          >
            <option disabled value="">
              {placeholder}
            </option>
            {children}
          </select>

          <span className="pointer-events-none absolute right-1 top-1/2 -translate-y-1/2">
            <ChevronDown color="white" />
          </span>
        </div>
      </div>
    )
  }
)

CartItemSelect.displayName = "CartItemSelect"

export default CartItemSelect